import { IFormlyConfig } from "AngularFormly";

export const vsWrapperName = "processChildren";

childrenWrapperConfig.$inject = ["formlyConfigProvider"];
export function childrenWrapperConfig(formlyConfigProvider: IFormlyConfig) {
  formlyConfigProvider.setWrapper({
    name: vsWrapperName,
    template: require("!html-loader!./index.html").default,
  });
}
